import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { trendingCategoryData } from '../../data/categories_data'
import { updateTrendingCategoryItemData } from '../../redux/counterSlice'
import Collection_category_filter from '../collectrions/collection_category_filter'

import CategoryItem from './categoryItem'

const FilterCategoryItem = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateTrendingCategoryItemData(trendingCategoryData.slice(0, 8)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      {/* <!-- Filter --> */}
      <Collection_category_filter />
      <CategoryItem />
    </div>
  )
}

export default FilterCategoryItem
